<template>
  <CModal
      :centered="true"
      :show.sync="studentViewPollQuestionModal"
      size="md"
      title="شرکت در نظرسنجی"
  >
    <div class="view__poll-question text-right">
      <CAlert class="desc text-sm" color="info"><span class="bold">توضیحات: </span>{{ poll.text }}</CAlert>
      <div
          v-for="(question, qIndex) in pollQuestions"
          :key="question.id"
          class="question__wrapper"
      >
        <div class=" text-sm"><span class="bold">سوال:</span> {{ question.text }}</div>

        <div
            v-for="(choice, index) in question.choices"
            v-show="choice.length"
            :key="index"
            class="mt-2">
          <CInputRadio
              @change="onCheck(qIndex, $event.target.id)"
              :name="`choices${qIndex}`"
              :id="index + 1">
            <template #label>
              {{ choice }}
            </template>
          </CInputRadio>
        </div>
      </div>
    </div>
    <template #footer>
      <CButton class="px-5" color="primary" @click="addPollAnswers">ثبت</CButton>
      <CButton class="px-5" color="danger"
               @click="studentViewPollQuestionModal = false">
        بستن
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    value: {
      type: Boolean,
    },
    poll: {
      type: Object,
    },
  },
  data() {
    return {
      pollQuestions: [],
      choices: [],

    };
  },
  computed: {
    studentViewPollQuestionModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    studentViewPollQuestionModal(val) {
      if (val)
        this.getPollQuestions()
    }
  },
  methods: {
    onCheck(qIndex, event) {
      this.choices[qIndex] = event
    },
    async getPollQuestions() {
      try {
        this.loading = true;
        const {data} = await axios.get(`/survey/${this.poll.id}/question`);
        this.pollQuestions = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async addPollAnswers() {
      try {
        this.loading = true;
        const payload = {
          choices: this.choices,
        };
        await axios.post(`/survey/${this.poll.id}`, payload).then(response => {
          if (response.data.status === 'ok') {
            this.choices = []
            this.studentViewPollQuestionModal = false
          }
        })

      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}

.question__wrapper {
  border-bottom: 1px solid #d8dbe0;
  padding: 8px 0;

  &:last-child {
    border-bottom: none;
  }
}
.view__poll-question {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
